// extracted by mini-css-extract-plugin
export const tags = "Tags-module--tags--1r6Jk";
export const tags__list = "Tags-module--tags__list--3-_4K";
export const tags__listItem = "Tags-module--tags__list-item--3E0p6";
export const tags__listItemLink = "Tags-module--tags__list-item-link--2Pbqe";